export { SHEET_COLUMN_TYPE } from '@nuvo-importer/common/sdk';

export const MAX_SELECTED_SHEET = 5;
